module.exports = __webpack_public_path__ + "img/Progress-Report-2.791a8b4d.png";